import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { useField } from 'formik';
import Error from 'src/shared-components/Form/Error';
import Label from 'src/shared-components/Form/Label';

const errorClass =
  'focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300 focus:outline-none  ';
const normalClass = 'focus:ring-indigo-500 focus:border-indigo-500 border-gray-300';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  className?: string;
  height?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  height = 'h-20',
  required = false,
  className,
  ...rest
}: TextAreaProps) => {
  const [field, { error, touched }] = useField({
    name: rest.name || '',
  });

  return (
    <div className={className}>
      {label && <Label text={label} name={rest.name || ''} required={required} />}
      <div className="mt-1 relative rounded-md">
        <textarea
          data-testid="textarea"
          aria-label={rest.name}
          className={`block w-full pr-3 sm:text-sm rounded-md border-0 bg-gray-100 placeholder-gray-400 ${height} ${
            error && touched ? errorClass : normalClass
          }`}
          {...field}
          {...rest}
        />
        {error && touched && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {error && touched && <Error error={error} />}
    </div>
  );
};

export default TextArea;
